import { Frame, Container, Content } from '@kinesis/bungle';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useNow } from '@/hooks/use-now';
import { useFlag } from '@/hooks/use-flag';
import { useGetGpcQuery } from '@/api/gpc';
import { useGetInventoryQuery } from '@/api/inventories';
import { Loading } from '@/components/loading';
import { GpcReport } from '@/components/gpc-report';

const Gpc = () => {
  const inventoryId = useInventoryId();
  const now = useNow();
  const enableBenchmark = useFlag('community.gpc-benchmark');
  const { data: gpc, isLoading: isLoadingGpc } = useGetGpcQuery(inventoryId);
  const { data: inventory, isLoading: isLoadingInventory } =
    useGetInventoryQuery(inventoryId);
  if (isLoadingGpc || isLoadingInventory) {
    return <Loading />;
  }
  return (
    <Container>
      <Frame>
        <Content background='white'>
          {gpc && inventory && (
            <GpcReport
              inventory={inventory}
              enableBenchmark={enableBenchmark}
              now={now}
              gpc={gpc}
            />
          )}
        </Content>
      </Frame>
    </Container>
  );
};

export { Gpc };
